import CustomerCareToolbar from './CustomerCareToolbar'

export default CustomerCareToolbar
